import React from "react";

interface IframeworkWinPanelList {
    data: {}
}
export const frameworkWinPanelList: IframeworkWinPanelList = {
    data: {
        "COMPONENTS": [
            {
                "name": "winPanelListContainerTest",
                "type": "Container",
                //"anchor": [0.5, 0.5],
                "visible": true,
                "x": 0,
                "y": 0,
                "child": []
            }
        ],
    }

};
export const winPanelListConfigurationContext = React.createContext(
    {}
);